export default class StringUtils
  BLANK_STRING_REGEX = /^\s*$/

  @capitalize: (str) ->
    str.charAt(0).toUpperCase() + str.slice(1);

  @isBlank: (str) ->
    !str || BLANK_STRING_REGEX.test(str)

  # HTML encode contents of a string, optionally preserving some nodes (ex: ["br","var"])
  @escapeHTML: (str, preserveNodes) ->
    fullParts = [{ escaped: false, val: str }] # Initial format, full unescaped string

    if preserveNodes
      # Iteratively break the string into array of parts in format {escaped:boolean, val:str} based on supplied nodes
      # to preserve

      matchSplit = (re, str) ->
        # Split a string with a regexp (with assumed match capture group) and mark each part appropriately as escped
        # or not, depending on if it's from the capture group
        parts = str.split(re)
        for part, index in parts
          parts[index] =
            escaped: index % 2 != 0
            val: part
        parts

      # For each node to preserve, tokenize and split on that node, marking node as escaped
      for node in preserveNodes
        # Regexp looks for node, including permutations of start/stop tag, included attributes, and self-closing tags
        nodeTagMatcher = new RegExp("(<\/?#{node}[^>]*\/?>)", "gi")

        # Iterate backwards through fullParts, escaping what needs escaping via tokenization
        for index in _.range(fullParts.length-1, -1, -1)
          part = fullParts[index]
          if !part.escaped
            newParts = matchSplit(nodeTagMatcher, part.val)
            # Rebuild fullParts, replacing part with expanded newParts
            fullParts = (fullParts.slice(0, index).concat(newParts)).concat(fullParts.slice(index+1))

    # Finally, for any parts marked as not escaped, HTML encode to text
    for part, index in fullParts
      if !part.escaped
        div = document.createElement("div")
        div.appendChild document.createTextNode(part.val)
        fullParts[index].val = div.innerHTML

    # Combine parts into just their values and return
    fullParts.map((part) -> part.val).join("")



// WEBPACK FOOTER //
// ./app/javascript/utils/platform/string_utils.js.coffee